export default __webpack_public_path__ + "static/peek-a-phone-019c27bea2bd7fca6e5de15784646026.webp";